
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
import AOS from 'aos';
require('owl.carousel');
require('jquery-mask-plugin');
require.context("./../vendor/wrapkit/js", true, /jquery.touchSwipe.min.js$/);
require.context("./../vendor/wrapkit/js", true, /bootstrap-touch-slider.js$/);
require.context("./../vendor/wrapkit/js", true, /perfect-scrollbar.jquery.min.js$/);
require.context("./../vendor/wrapkit/js", true, /custom.js$/);

$(function () {
    "use strict";
    // ==============================================================
    //This is for preloader
    // ==============================================================
    $(function () {
        $(".preloader").fadeOut();
    });
    var set = function () {
        var topOffset = 390;
        var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
        height = height - topOffset;
        if (height < 1) height = 1;
        if (height > topOffset) {
            $(".page-wrapper").css("min-height", (height) + "px");
        }

    };
    $(window).ready(set);
    $(window).on("resize", set);

    // ==============================================================
    //Tooltip
    // ==============================================================
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })
    // ==============================================================
    //Popover
    // ==============================================================
    $(function () {
        $('[data-toggle="popover"]').popover()
    })
    // ==============================================================
    // For mega menu
    // ==============================================================
    jQuery(document).on('click', '.mega-dropdown', function (e) {
        e.stopPropagation()
    });
    jQuery(document).on('click', '.navbar-nav > .dropdown', function(e) {
        e.stopPropagation();
    });
    $(".dropdown-submenu").click(function(){
        $(".dropdown-submenu > .dropdown-menu").toggleClass("show");
    });
    // ==============================================================
    // Resize all elements
    // ==============================================================
    $("body").trigger("resize");
    // ==============================================================
    //Fix header while scroll
    // ==============================================================
    var wind = $(window);
    wind.on("load", function() {
        var bodyScroll = wind.scrollTop(),
            navbar = $(".topbar");
        if (bodyScroll > 100) {
            navbar.addClass("fixed-header animated slideInDown")
        } else {
            navbar.removeClass("fixed-header animated slideInDown")
        }
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 200) {
            $('.topbar').addClass('fixed-header animated slideInDown');
            $('.bt-top').addClass('visible');
        } else {
            $('.topbar').removeClass('fixed-header animated slideInDown');
            $('.bt-top').removeClass('visible');
        }
    });
    // ==============================================================
    // Animation initialized
    // ==============================================================
    AOS.init();
    // ==============================================================
    // Back to top
    // ==============================================================
    $('.bt-top').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });
    // ==============================================================
    // Modal video stop on close
    // ==============================================================
    $('.modal').on('hidden.bs.modal', function () {
        callPlayer('yt-player', 'stopVideo');
    });
    // ==============================================================
    // This is for the remove target blank from href
    // ==============================================================
    //$('a[target="_blank"]').removeAttr('target');
    $('#betra_uid_wrap').hide();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js